import { validateEmail, getSession } from "../../global";
import { isNormalInteger, isNumber, isPositiveFloat } from "../../utils/util";


const findDuplicates = (CustomerReferenceNumber, grid) => {
    const arrayForSort = [...grid]
    let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
        return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
    });
    let results = [];
    for (let i = 0; i < sorted_grid.length - 1; i++) {
        if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
            results.push(sorted_grid[i]);
        }
    }
    return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
}


export const calculateErrors = (grid, destinations, userInfo, services, codAmountLimit, data, codWeightLimits) => {
    let errorsOccured = [];
    grid.map((element, index) => {
        Object.keys(element).map(key => {
            let gridObj = {
                'ConsigneeName': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignee Name is Required",
                            fieldName: "Consignee Name"
                        })
                    } else {
                        if (element[key].length > 49) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Maximum length is 50 characters.",
                                fieldName: "Consignee Name"

                            })
                        }
                    }
                },
                'ConsigneeAddress': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignee Address is Required.",
                            fieldName: "Consignee Address"
                        })
                    } else {
                        if (element[key].length > 255) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Maximum length is 255 characters.",
                                fieldName: "Consignee Address"
                            })
                        }
                    }
                },
                'ConsigneeMobileNumber': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignee Mobile Number is Required.",
                            fieldName: "Consignee Mobile Number"
                        })
                    } else if (element[key] && element[key].length > 49) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Maximum length is 50 characters.",
                            fieldName: "Mobile Number"
                        })
                    }
                    // else {
                    //     if (element[key].length < 11 || element[key].length > 12 || !isNormalInteger(element[key])) {
                    //         errorsOccured.push({
                    //             index,
                    //             key,
                    //             error: "Invalid Phone# format found, format should be (923xxxxxxxxx).",
                    //             fieldName: "Consignee Mobile Number"
                    //         })
                    //     }
                    // }
                },
                'ConsigneeEmail': () => {
                    if (element[key] !== undefined && element[key] !== "" && validateEmail(element[key])) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Invalid Email Format.",
                            fieldName: "Consignee Email"
                        })
                    } else if (element[key] && element[key].length > 49) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Maximum length is 50 characters.",
                            fieldName: "Consignee Email"
                        })
                    }
                },
                'DestinationCity': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Destination is Required.",
                            fieldName: "Destination City"
                        })
                    } else {
                        if (destinations.filter(y => y.text.toUpperCase() == (element[key] && element[key].toUpperCase())).length == 0) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Invalid destination, Select from dropdown.",
                                fieldName: "Destination City"
                            })
                        }
                    }
                },
                'Pieces': () => {
                    if (!element[key] || element[key] <= 0) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Piece is Required.",
                            fieldName: "Pieces"
                        })
                    } else {
                        if (element[key] > 99 || !isNormalInteger(element[key])) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Pieces must be less than or equals to 99.",
                                fieldName: "Pieces"
                            })
                        }
                    }
                },
                'Weight': () => {
                    if (!element[key] || element[key] <= 0) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Weight is Required.",
                            fieldName: "Weight"
                        })
                    } else {
                        if (element[key] > 99 || isNaN(element[key]) || !isPositiveFloat(element[key])) {


                            let maxAllowedWeight = data.isCod ? 99 : 9999;
                                
                            const accountWeightLimit = codWeightLimits?.find(
                                limit => limit.accountNo.toUpperCase() === data.accountNo.toUpperCase()
                            );
                
                            if (accountWeightLimit) {
                                maxAllowedWeight = Math.max(maxAllowedWeight, accountWeightLimit.weight);
                            }



                                
                            if (element[key]  > maxAllowedWeight) {
                                errorsOccured.push({
                                    index,
                                    key,
                                    error: `Weight must be less than or equals to ${maxAllowedWeight} kg.`,
                                    fieldName: "Weight"
                                })
                            } 
                        }
                    }
                },
                'CODAmount': () => {
                    if (!element[key] || element[key] < 0) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "COD Amount is Required.",
                            fieldName: "COD Amount"
                        })
                    } else {
                        // if ((!userInfo.isZeroCodAllowed && element[key].CODAmount < 0) || element[key].CODAmount > 99999 || !isNumber(element[key].CODAmount)) {
                        
                        const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == data?.accountNo.toUpperCase());
                        let codAmountL = 99999;
                        if(amountLimitCheck.length > 0) {
                            codAmountL = amountLimitCheck[0].amount;
                        }

                        if (((!userInfo.isZeroCodAllowed && element[key].CODAmount <= 0)  || element[key] > codAmountL || !isNormalInteger(element[key]))) {
                            errorsOccured.push({
                                index,
                                key,
                                error: `Cod Amount must be greater than 0 and less than ${codAmountL}` ,
                                fieldName: "COD Amount"
                            })
                        }
                    }
                },
                'CustomerReferenceNumber': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Customer Reference Number is Required.",
                            fieldName: "Customer Reference Number"
                        })
                    } else {
                        if (!userInfo.isDuplicateOrderAllowed && findDuplicates(element[key], grid)) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Duplicate Customer Reference Number not allowed.",
                                fieldName: "Customer Reference Number"
                            })
                        }
                    }
                },
                'ServiceType': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Service Type is Required.",
                            fieldName: "Service Type"
                        })
                    } else {
                        if (services.filter(y => y.toUpperCase() == (element[key] && element[key].toUpperCase())).length == 0) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Invalid Service Type, Select from dropdown.",
                                fieldName: "Service Type"
                            })
                        }
                    }
                },
                'ProductDetails': () => {
                    if (element[key] && element[key].length > 599) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Maximum length is 600 characters.",
                            fieldName: "Product Details"
                        })
                    }
                },
                'Remarks': () => {
                    if (element[key] && element[key].length > 599) {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Maximum length is 600 characters.",
                            fieldName: "Remarks"
                        })
                    }
                },
                'default': () => (console.log())
            };
            let executeValidation = gridObj[key] || gridObj['default'];
            return executeValidation();
        })
    })

    return errorsOccured;
}